// TODO check if we need zod validation in nev files in future
import * as z from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.url({ error: 'VITE_API_URL must be an absolute URL' }),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const errors = z.prettifyError(parsed.error);
  throw new Error(`Invalid dashboard environment (see apps/dashboard/.env.example):\n${errors}`);
}

export const env = parsed.data;
